import { PricingPayload } from "../../stores/PricingStore/Types";

// The one price a course page says about itself, on the hero card and in the
// sticky bar, taken from the same pricing data the pricing section uses so
// all three agree: the visitor's currency, the visitor's tier. The figure
// stands alone, with no "paid once" after it (Chris, 29 Oct 2026).
export interface PriceLine {
  prefix: string; // "" now that every page leads with the full price
  symbol: string;
  amount: string;
  code: string | null; // shown only when the symbol alone is ambiguous
  // The monthly way of paying, for the hero card, which has room for it:
  // "or £100 a month for 3 months (£300)", word for word what the pricing
  // card says. Absent without a payment plan.
  alternative?: string;
}

// Six of our currencies share the dollar sign. The rest have a symbol of
// their own, so the code would only be noise.
const AMBIGUOUS_SYMBOLS = ["$", ""];

export const priceLineFor = (
  pricing: PricingPayload | undefined
): PriceLine | null => {
  if (!pricing || pricing.kind !== "pricing") return null;
  const single = pricing.single_course_pricing;
  if (!single) return null;

  const symbol = single.currency_symbol || "";
  const code = AMBIGUOUS_SYMBOLS.includes(symbol) ? single.currency_code : null;

  if (!single.amount) return null;

  const total = single.payment_plan_total_amount
    ? ` (${symbol}${single.payment_plan_total_amount})`
    : "";
  const alternative = single.payment_plan_amount
    ? `or ${symbol}${single.payment_plan_amount} a month for ${single.payment_plan_installment_count || 3} months${total}`
    : undefined;

  return { prefix: "", symbol, amount: single.amount, code, alternative };
};
